import { EntityTypeId } from "../../../../core/entity/EntityTypeId.enum"
import type { Entity } from "../../../../core/entity/index"

const grassWaveEntityIdList = [
  EntityTypeId.Desert,
  EntityTypeId.Plain,
  EntityTypeId.River,
  EntityTypeId.Marsh,
  EntityTypeId.Lake,
  EntityTypeId.Sea,
  EntityTypeId.Shoal,
]

export default function isEntityWithGrassWaves(ent: Entity) {
  const { etype_id } = ent
  return grassWaveEntityIdList.includes(etype_id)
}